/* src/app/components/shop/products/product-carousel-three/product-carousel-three.component.scss */
.product-item-2 .color1-f-s-10 {
  color: #ffa500;
  font-size: 10px;
  font-family: roboto;
  margin: 10px 0px;
}
.product-item-2 .color-f-s-10 {
  color: #ffa500;
  font-size: 10px;
  font-family: roboto;
}
.product-item-2 .l-20 {
  left: -20px;
}
/*# sourceMappingURL=product-carousel-three.component.css.map */
